import * as React from 'react';
import { getUserDashboards } from './../../ApiUtils/ApiUtils'; 
import * as ConsoleStore from '../../store/Console';
import PowerBIDashboard from './Dashboard/PowerBIDashboard'; 
import { ApplicationState } from '../../store';
import { bindActionCreators, Dispatch } from 'redux';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

interface Dashboard {
    key: string;
    name: string;
    type: number;
}

type UserDashboardsProps = {} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface UserDashboardsState {
    dashboards: Dashboard[];
    selectedDashboard: string | null;
}

class UserDashboards extends React.Component<UserDashboardsProps, UserDashboardsState> {
    constructor(props: UserDashboardsProps) {
        super(props);
        this.state = {
            dashboards: [],
            selectedDashboard: null,
        };
    }

    async componentDidMount() {
        try {
            const response = await getUserDashboards();
            if (response && response.data.length > 0) {
                // Filter dashboards to only include PowerBI
                const filteredDashboards = response.data.filter((d: Dashboard) => d.type === 2);
                this.setState({
                    dashboards: filteredDashboards,
                    selectedDashboard: filteredDashboards.length > 0 ? filteredDashboards[0].key : null,
                });
            }
        } catch (error) {
            console.error("Error fetching dashboards:", error);
        }
    }

    handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ selectedDashboard: event.target.value });
    };

    public render() {
        const { dashboards, selectedDashboard } = this.state;

        return (
            <div>
              <div style={{ border:"0px solid #ccc", minHeight:"265px"}}>
                    <div className="title">
                        <div style={{ position: 'absolute', paddingLeft: "0.75rem"}}>
                            <h5 className="mt-2">Policy Monitoring</h5>
                        </div>
                        <div style={{ textAlign: 'right', minHeight: '40px', minWidth: '340px', padding: '5px 0', paddingRight: "0.75rem"}}>
                            <select id="selectDashboard"
                                value={selectedDashboard || ""}
                                onChange={this.handleChange}
                                style={{ minHeight: "30px", minWidth: "170px", borderRadius: '15px', fontSize: '9pt', padding: '4px 4px 4px 8px', appearance: 'none' }}
                            >
                                <option value="">Select Dashboard</option>
                                {dashboards.map((dashboard) => (
                                    <option key={dashboard.key} value={dashboard.key}>
                                        {dashboard.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                </div>
                    <div style={{ width: "100%", minHeight: "150px" }}>
                    {selectedDashboard && <PowerBIDashboard dashboardKey={selectedDashboard} />}
                </div>
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDashboards);
